import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CardBox, Page, FormInput, FormTextarea } from '../../components'
import { fetchDictionary, newDictionary, editDictionary } from '../../api'
import { back, replace } from '../../actions/nav-actions';
import { retrieve } from '../../actions/project-actions';
import { notify } from '../../utils';

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            new_key: '',
            new_value: '',
            dictionary: {
                data: {}
            },
        }
        this.getData = this.getData.bind(this);
        this.onRequest = this.onRequest.bind(this);
        this.getParams = this.getParams.bind(this);
    }
    getParams() {
        return this.props.match.params || {};
    }
    componentWillReceiveProps(newProps) {
        const params = newProps.match.params || {};
        if (params.id) {
            this.getData(params);
        }
    }
    componentDidMount() {
        this.getData(this.getParams());
    }
    getData(params) {
        if (params.id) {
            fetchDictionary(this.props.user.token, params.id)
                .then((dictionary) => this.setState({ dictionary }))
                .catch((err) => {
                    alert(err.message);
                })
        }
    }
    onRequest(event) {
        if (event) event.preventDefault();
        const params = this.getParams();
        if (params.id) {
            editDictionary(
                this.props.user.token,
                params.id,
                {
                    lang: this.state.dictionary.lang,
                    dictionary: this.state.dictionary.data
                }
            ).then((dictionary) => {
                this.props.retrieve(this.props.user.token);
                this.props.replace(`/dictionaries/${dictionary._id}`);
                notify("Dictionary updated", "Updated data!")
            }).catch(err => {
                alert(err.message);
            })
            return;
        }
        newDictionary(
            this.props.user.token,
            {
                lang: this.state.dictionary.lang,
                dictionary: this.state.dictionary.data
            }
        ).then((dictionary) => {
            this.props.retrieve(this.props.user.token);
            this.props.replace(`/dictionaries/${dictionary._id}`);
            notify("Dictionary created", "Saved data!")
        }).catch(err => {
            alert(err.message);
        })
    }
    render() {
        const values = Object.keys(this.state.dictionary.data).sort((a, b) => a > b);
        return (
            <Page title="Edit Dictionary">
                <CardBox>
                    <form onSubmit={this.onRequest}>
                        <p><b>Fill in the key and value to add texts in the list</b></p>
                        <div className="row">
                            <FormInput
                                onChange={(lang) => {
                                    let { dictionary } = this.state;
                                    dictionary.lang = lang;
                                    this.setState({ dictionary });
                                }}
                                required
                                containerClass="col-3"
                                disabled={this.state.dictionary.lang === 'en-US'}
                                value={this.state.dictionary.lang}
                                placeholder="Dictionary Language" />
                        </div>
                        {this.state.dictionary.lang === 'en-US' &&
                            <div className="row">
                                <FormInput
                                    onChange={(new_key) => {
                                        this.setState({ new_key });
                                    }}
                                    containerClass="col-5"
                                    value={this.state.new_key}
                                    placeholder="Key" />
                                <FormTextarea
                                    onChange={(new_value) => {
                                        this.setState({ new_value });
                                    }}
                                    containerClass="col-6"
                                    value={this.state.new_value}
                                    placeholder="Value" />
                                <div className="col-1">
                                    <button onClick={(event) => {
                                        event.preventDefault()
                                        let { dictionary, new_value, new_key } = this.state;
                                        if (new_key.trim().length === 0 || new_value.trim().length === 0) return;
                                        dictionary.data[new_key] = new_value;
                                        this.setState({ dictionary, new_key: '', new_value: '' })
                                    }}
                                        className="btn btn-info btn-block">
                                        <i className="mdi mdi-plus"></i>
                                    </button>
                                </div>
                            </div>
                        }

                        <div style={{ margin: '16px 0' }}>
                            <p><b>List of current texts</b></p>
                            {values.length === 0 &&
                                <span>No Values</span>
                            }
                            {values.map((key, index) => {
                                return (
                                    <div className="row" key={index} style={{ marginBottom: 16, borderBottomStyle: 'solid', borderBottomWidth: 1, borderBottomColor: '#CCC' }}>
                                        <FormInput
                                            onChange={(text) => {
                                                if (text.indexOf(' ') !== -1) return;
                                                let { dictionary } = this.state;
                                                dictionary.data[text] = dictionary.data[key];
                                                delete dictionary.data[key]
                                                this.setState({ dictionary })
                                            }}
                                            required
                                            disabled={this.state.dictionary.lang !== 'en-US'}
                                            containerClass="col-5"
                                            value={key}
                                            placeholder="Key" />
                                        <FormTextarea
                                            onChange={(text) => {
                                                let { dictionary } = this.state;
                                                dictionary.data[key] = text;
                                                this.setState({ dictionary })
                                            }}
                                            required={this.state.dictionary.lang === 'en-US'}
                                            containerClass="col-6"
                                            value={this.state.dictionary.data[key]}
                                            placeholder="Value" />
                                        {/**this.state.dictionary.lang === 'en-US' &&
                                            <div className="col-1">
                                                <button onClick={(event) => {
                                                    event.preventDefault()
                                                    let { dictionary } = this.state;
                                                    if (dictionary.data[key]) {
                                                        delete dictionary.data[key];
                                                    }
                                                    this.setState({ dictionary })
                                                }}
                                                    className="btn btn-danger btn-block">
                                                    <i className="mdi mdi-delete"></i>
                                                </button>
                                            </div>
                                            **/}
                                    </div>
                                )
                            })}
                        </div>

                        <div>
                            <button className="btn bnt-block btn-info">
                                {this.state.dictionary._id ? "UPDATE INFORMATIONS" : "CREATE DICTIONARY"}
                            </button>
                        </div>

                    </form>
                </CardBox>
            </Page>
        )
    }
}

const mapStateToProps = state => ({ user: state.authReducer.user })

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back());
    },
    retrieve(token) {
        dispatch(retrieve(token));
    },
    replace(routeName) {
        dispatch(replace(routeName))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)


// WEBPACK FOOTER //
// ./src/routers/Dictionaries/Form.js